export class CompanyBusinessLineDetail {
    public id: number |null;
    public company_id:number;
    public business_line_id:number;
    public billing_period:number|null;

    constructor(data: CompanyBusinessLineDetailData | undefined | null = undefined) {
        if (data === undefined || data === null) {
            this.id = null;
            this.company_id = 0;
            this.business_line_id = 0;
            this.billing_period = null;

        } else {
            this.id = data.id;
            this.company_id = data.company_id;
            this.business_line_id = data.business_line_id;
            this.billing_period = data.billing_period;

        }
    }

    serializeData(without_relations: boolean | Array<string> = false):CompanyBusinessLineDetailData {
        const serialized_data:CompanyBusinessLineDetailData = {
            id: this.id,
            company_id: this.company_id,
            business_line_id: this.business_line_id,
            billing_period: this.billing_period,
        }

        return serialized_data;
    }
}



export type CompanyBusinessLineDetailData = {
    id: number |null;
    company_id:number;
    business_line_id:number;
    billing_period:number|null;

}
